<div
  [@openClose]="animateState"
  (@openClose.done)="redirect($event)"
  class="redirect-loader d-flex justify-content-center align-items-center"
>
  <dxc-loader></dxc-loader>
</div>
